<!-- 予約/購入エラー -->
<template>
  <TemplateMfittBookingVacantSeatsError />
</template>

<script>
import TemplateMfittBookingVacantSeatsError from "@/views/Templates/MFITT/TemplateMfittBookingVacantSeatsError";

import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";

export default {
  name: "MfittBookingVacantSeatsError",
  components: {
    TemplateMfittBookingVacantSeatsError,
  },
  setup() {},
};
</script>
